export default __webpack_public_path__ + "static/sourceForge-icon-621ecafea401520f9003738cc317cd13.png";